import { defineFakeRoute } from 'vite-plugin-fake-server/client';
import type { InstanceRow, InstanceSort } from '@/services/business/instances';
import { resultError, resultSuccess, routeParam } from '../business/utils';
import { gatewayInstances, gatewayServers } from './fixtures';

const ranks = { offline: 0, draining: 1, ready: 2 };
const sorts: InstanceSort[] = ['id', 'status', 'lastHeartbeatAt'];
let detailFailurePending = true;
function instanceRows(): InstanceRow[] {
  return gatewayInstances.map((instance) => {
    const server = gatewayServers.find((host) => host.id === instance.serverId);
    if (!server) throw new Error(`Missing host for ${instance.id}`);
    return {
      ...instance,
      serverName: server.name,
      serverStatus: server.status,
      serverIp: server.ip,
    };
  });
}
export default defineFakeRoute([
  {
    url: '/platform/instances',
    method: 'get',
    response: ({ query }) => {
      const page = Number(query.page ?? 1),
        pageSize = Number(query.page_size ?? 10);
      const sort = routeParam(query.sort) as InstanceSort | undefined;
      const order = routeParam(query.order),
        status = routeParam(query.status);
      if (
        !Number.isInteger(page) ||
        page < 1 ||
        !Number.isInteger(pageSize) ||
        pageSize < 1 ||
        pageSize > 100 ||
        (sort !== undefined && !sorts.includes(sort)) ||
        (order !== undefined && !['asc', 'desc'].includes(order)) ||
        !!sort !== !!order ||
        (status !== undefined && !['ready', 'draining', 'offline'].includes(status))
      ) {
        return resultError('查询参数无效，请检查分页、筛选和排序条件', 422);
      }
      const q = (routeParam(query.q) ?? '').trim().toLowerCase();
      const items = instanceRows()
        .filter(
          (instance) =>
            (!status || instance.status === status) &&
            (!q ||
              [instance.id, instance.serverId, instance.serverName].some((value) =>
                value.toLowerCase().includes(q),
              )),
        )
        .sort((a, b) => {
          if (!sort)
            return ranks[a.status] - ranks[b.status] || a.id.localeCompare(b.id);
          const av = sort === 'status' ? ranks[a.status] : a[sort],
            bv = sort === 'status' ? ranks[b.status] : b[sort];
          if (av === null || bv === null)
            return av === bv ? a.id.localeCompare(b.id) : av === null ? 1 : -1;
          const comparison =
            typeof av === 'number' && typeof bv === 'number'
              ? av - bv
              : String(av).localeCompare(String(bv));
          return comparison * (order === 'desc' ? -1 : 1) || a.id.localeCompare(b.id);
        });
      return resultSuccess({
        items: items.slice((page - 1) * pageSize, page * pageSize),
        total: items.length,
        page,
        page_size: pageSize,
      });
    },
  },
  {
    url: '/platform/instances/:id',
    method: 'get',
    response: ({ params }) => {
      const instance = instanceRows().find((row) => row.id === routeParam(params.id));
      if (!instance) return resultError('网关实例不存在或已移除', 404);
      if (instance.id === 'gateway-sh-02' && detailFailurePending) {
        detailFailurePending = false;
        return resultError('实例详情查询超时，请重试', 504);
      }
      return resultSuccess(instance);
    },
  },
]);
